import React from "react";
import { CBreadcrumb, CBreadcrumbItem } from "@coreui/react";
import { Link } from "react-router-dom";
const BreadCrumb = ({ linkList }) => {
  //TODO: Fix UI not taking 100% of screen width
  //TODO: Make every link clickable except the current one
  const capitalize = (str) => {
    if (str === "faq") {
      return "FAQ";
    }
    str = str.split("-");
    let res = "";
    str.forEach((item) => {
      res += item.charAt(0).toUpperCase() + item.slice(1) + " ";
    });
    res = res.slice(0, res.length - 1);
    return res;
  };
  return (
    <div className="container-fluid my-5">
      <CBreadcrumb style={{ "--bs-breadcrumb-divider": "'>'" }}>
        {linkList.map((link, index) => {
          return (
            <CBreadcrumbItem
              key={index}
              className={`breadcrumb-item ${
                index === linkList.length - 1 ? "active" : ""
              }`}
              style={{
                cursor: index !== linkList.length - 1 ? "pointer" : "auto",
              }}
            >
              {index !== linkList.length - 1 ? (
                <Link to={link} underline={"hover"}>
                  <strong>
                    <label>{capitalize(link)}</label>
                  </strong>
                </Link>
              ) : (
                <strong>
                  <label>{capitalize(link)}</label>
                </strong>
              )}
            </CBreadcrumbItem>
          );
        })}
      </CBreadcrumb>
    </div>
  );
};

export default BreadCrumb;
